// main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

const app = createApp(App)


// 라우터와 vuetify 등록
app.use(router)
app.use(vuetify)

// 애플리케이션 마운트
app.mount('#app')
